<template>
  <div>
    <div
      class="flex items-center"
      :class="{
        'justify-between':$route.name !== 'SharedWithMe',
        'justify-end': $route.name === 'SharedWithMe'
      }"
    >
      <div
        v-if="selectedPresentations.length !== 0"
        v-show="$route.name !== 'SharedWithMe'"
      >
        <aha-button
          :disabled="selectedSharedPresentation"
          has-margin-right
          size="xl"
          variant="danger"
          @click="showingDelelePresentationsModal = true"
        >
          <aha-icon
            name="delete"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>Delete</span>
        </aha-button>

        <aha-button
          :disabled="selectedSharedPresentation"
          has-margin-right
          size="xl"
          variant="white"
          @click="openMovePresentationModal"
        >
          <aha-icon
            name="move"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>Move to</span>
        </aha-button>

        <span class="text-base-90">
          <span>{{ selectedPresentations.length }} selected presentation(s)</span>
          <span class="ml-1 cursor-pointer" @click="handleCloseButtonClick">
            <aha-icon
              name="close"
              width="14"
              height="14"
              viewBox="0 0 24 24"
            />
          </span>
        </span>
      </div>

      <div
        v-if="selectedPresentations.length === 0 && $route.name !== 'SharedWithMe'"
        class="flex items-center"
      >
        <div>
          <!-- desktop new presentation button -->
          <aha-button
            v-if="isShowNewPresentationButton"
            class="md:inline-flex hidden mr-3"
            size="xl"
            @click="onClickNewPresentation"
          >
            <aha-icon
              name="add"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
            <span>New Presentation</span>
          </aha-button>

          <!-- mobile new presentation button -->
          <aha-button
            v-if="isShowNewPresentationButton"
            class="md:hidden inline mr-3"
            size="xl"
            @click="handleNewClick"
          >
            <aha-icon
              name="add"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
            <span>New Presentation</span>
          </aha-button>

          <aha-context-menu ref="context-menu-new">
            <aha-context-menu-header>
              Start a new presentation
            </aha-context-menu-header>
            <ul>
              <li
                v-if="workingMode === 'personal'"
                class="block context-menu-item md:hidden"
                @click="handleClickChooseTemplate"
              >
                <aha-icon
                  class="text-purple-50"
                  height="20"
                  width="20"
                  viewBox="0 0 20 20"
                  name="template"
                />
                <span>From a Template</span>
              </li>
              <li
                class="context-menu-item"
                @click="onClickNewPresentation"
              >
                <aha-icon
                  class="text-brand-a100"
                  height="20"
                  width="20"
                  viewBox="0 0 24 24"
                  name="file"
                />
                <span class="inline md:hidden">From Scratch</span>
                <span class="hidden md:inline">New Presentation</span>
              </li>
            </ul>
          </aha-context-menu>
        </div>

        <aha-button
          v-if="$route.name === 'FolderDetail'"
          size="xl"
          class="inline mr-3"
          @click="onClickNewPresentation"
        >
          <aha-icon
            name="add"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <span>New Presentation</span>
        </aha-button>

        <aha-button
          v-if="isShowNewFolderButton"
          class="px-2.5 sm:px-4 inline mr-3"
          variant="white"
          size="xl"
          @click="handleClickCreateNew('folder')"
        >
          <aha-icon
            class="-mt-0.5"
            name="newfolder"
            height="19"
            width="19"
            viewBox="0 0 25 25"
          />
          <span class="hidden sm:inline">New Folder</span>
        </aha-button>
        <aha-button
          v-if="isShowImportButton"
          class="px-2.5 sm:px-4 import-button"
          variant="white"
          size="xl"
          icon-name="import"
          :submitting="isImportingSlides"
          @click="openImportModal()"
        >
          <aha-spinner v-if="isImportingSlides" class="sm:mr-1" />
          <span class="hidden sm:inline-block relative -left-0.5">Import</span>
        </aha-button>
      </div>

      <sort-by
        v-if="!isHideSortBy"
        class="hidden md:inline-block"
      />
    </div>

    <modal-create-new-folder
      v-if="isModalCreateNewFolderShowing"
      @hide="handleHideModal('create-new-folder')"
    />
    <modal-create-new-team-folder
      v-if="isModalCreateNewTeamFolderShowing"
      @hide="handleHideModal('create-new-team-folder')"
    />
    <modal-import
      v-if="$store.state.openImportModal"
      :type="'importPpt'"
    />

    <modal-move-presentation
      v-if="isModalMovePresnShowing"
      :selectedPresentations="selectedPresentations"
      @hide="handleHideModal('move-presentation')"
    />
    <modal-move-team-presentatation
      v-if="isModalMoveTeamPresentationShowing"
      :selectedPresentations="selectedPresentations"
      @hide="handleHideModal('move-team-presentation')"
    />
    <modal-delete-presentations
      v-if="showingDelelePresentationsModal"
      :deleted-presentations="selectedPresentations"
      @hide="showingDelelePresentationsModal = false"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

// utils
import Utils from '@/util'
import EventBus from '@/eventBus'

// constants
import constants from '@/constant'

// modals
import ModalCreateNewFolder from '@/components-v2/modals/CreateNewFolder'
import ModalCreateNewTeamFolder from '@/components-v2/modals/CreateNewTeamFolder'
import ModalImport from '@/components-v2/modals/Import.vue'
import ModalMovePresentation from '../modals/MovePresentations.vue'
import ModalMoveTeamPresentatation from '../modals/MoveTeamPresentations.vue'
import ModalDeletePresentations from '../modals/DeletePresentations.vue'

// components

import SortBy from './SortBy.vue'
import CreateNewPresentationMixin from '@/mixins/presentation/CreateNewPresentationMixin'

export default {
  components: {
    SortBy,
    ModalCreateNewFolder,
    ModalCreateNewTeamFolder,
    ModalDeletePresentations,
    ModalImport,
    ModalMovePresentation,
    ModalMoveTeamPresentatation,
  },
  mixins: [CreateNewPresentationMixin],
  props: {
    isHideNewFolder: {
      type: Boolean,
      default: false,
    },
    isHideSortBy: {
      type: Boolean,
      default: false,
    },
    isFromSearchingNoDataComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newPresentationTrigger: null,
      isModalCreateNewFolderShowing: false,
      isModalCreateNewTeamFolderShowing: false,
      isModalImportShowing: false,
      isModalMovePresnShowing: false,
      isModalMoveTeamPresentationShowing: false,
      showingDelelePresentationsModal: false,
      permissions: constants.permissions,
    }
  },
  computed: {
    presentationSelected() {
      return this.presentations.some((presentation) => presentation.selected)
    },
    ...mapState({
      selectedPresentations: (state) => {
        return state.presentations.filter((presentation) => presentation.selected)
      },
      selectedSharedPresentation: (state) => {
        if (
          (state.currentUser.accountRole === constants.workspace.OWNER
          || state.currentUser.accountRole === constants.workspace.ADMIN)
          && state.workingMode === constants.workspace.TEAM) return false
        const selectedPresentations = state.presentations
          .filter((presentation) => presentation.selected)
        return selectedPresentations.some((p) => p.userId !== state.currentUser.id)
      },
      importStatus: (state) => state.importStatus,
      presentations: (state) => state.presentations,
      isImportingSlides: (state) => state.importStatus === 2 || state.importStatus === 3,
      workingMode: (state) => state.workingMode,
      currentUser: (state) => state.currentUser,
    }),
    isShowNewPresentationButton() {
      if (this.$route.name === 'Presentations') return true
      if (this.$route.name === 'Team' || this.$route.name === 'TeamFolderDetail') {
        if (this.currentUser && this.currentUser.permissions &&
          this.currentUser.permissions.includes(this.permissions.CREATE_PRESENTATION)) {
          return true
        }
      }
      return false
    },
    isShowNewFolderButton() {
      if (this.$route.name === 'FolderDetail' || this.$route.name === 'TeamFolderDetail') {
        return false
      }
      if (this.isHideNewFolder) return false
      if (this.$route.name === 'Team' && this.currentUser.accountRole === 'viewer') return false
      if (this.$route.name === 'Team' && this.currentUser.permissions && !this.currentUser.permissions.includes(this.permissions.CREATE_FOLDER)) return false
      if (this.$route.name === 'Team' && this.currentUser.permissions && this.currentUser.permissions.includes(this.permissions.CREATE_FOLDER)) return true
      return true
    },
    isShowImportButton() {
      if (this.$route.name === 'Team' || this.$route.name === 'TeamFolderDetail') return false
      return true
    },
  },
  mounted() {
    EventBus.$on('my-presentations:create-new-presentation', ({ trigger }) => {
      this.newPresentationTrigger = trigger
      this.handleClickCreateNew('file')
    })
  },
  destroyed() {
    EventBus.$off('my-presentations:create-new-presentation')
  },
  methods: {
    ...mapActions(['setPresentationsAction']),
    handleNewClick() {
      this.$refs['context-menu-new'].show()
    },
    handleClickCreateNew(createNewSelectionIcon) {
      this.openCreateNewModal(createNewSelectionIcon)
    },
    openCreateNewModal(createNewSelectionIcon) {
      if (createNewSelectionIcon === 'file') {
        // this.isCreatingNewPresn = true // dont show modal anymore
        // gọi API -> vào editor
        this.createNewPresentation(this.newPresentationTrigger)
      } else if (createNewSelectionIcon === 'folder') {
        if (this.workingMode === constants.workspace.PERSONAL) {
          this.isModalCreateNewFolderShowing = true
        }
        if (this.workingMode === constants.workspace.TEAM) {
          this.isModalCreateNewTeamFolderShowing = true
        }
        this.gaTrackEvent('New > Create New Folder > Open modal')
        Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_LIST, 'New > Create New Folder > Open modal', null, null, {
          isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
          isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
          role: this.$store.state.currentUser.accountRole || null,
          teamId: this.$store.state.currentAccount.id || null,
        })
      }
    },
    openImportModal() {
      this.$store.state.openImportModal = true
      if (this.isFromSearchingNoDataComponent) {
        Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_LIST, 'Import > Open modal', 'WhenSearching')
      } else {
        Utils.gaTrackEvent(
          constants.gaCategories.PRESENTATION_LIST,
          'Import > Open modal',
        )
      }
    },
    handleHideModal(type) {
      if (type === 'create-new-folder') {
        this.isModalCreateNewFolderShowing = false
        this.gaTrackEvent('New > Create New Folder > Close modal')
      } else if (type === 'create-new-team-folder') {
        this.isModalCreateNewTeamFolderShowing = false
        this.gaTrackEvent('')
      } else if (type === 'create-new-presentation') {
        // this.isModalCreateNewPresentationShowing = false
        // this.gaTrackEvent('New > Create New Presentation > Close modal')
      } else if (type === 'move-presentation') {
        this.isModalMovePresnShowing = false
        this.gaTrackEvent('Move > Move presentations to folder > Close modal')
      } else if (type === 'move-team-presentation') {
        this.isModalMoveTeamPresentationShowing = false
      }
    },
    gaTrackEvent(label) {
      Utils.gaTrackEvent(
        constants.gaCategories.PRESENTATION_LIST,
        label,
      )
    },
    handleCloseButtonClick() {
      const newPresentations = this.presentations.map((presentation) => {
        return { ...presentation, selected: false }
      })

      this.setPresentationsAction(newPresentations)
    },
    handleClickChooseTemplate() {
      this.$router.push('/apps/template-library?from=mobileMenu')
    },
    onClickNewPresentation() {
      this.newPresentationTrigger = 'New dropdown menu'
      this.openCreateNewModal('file')
    },
    openMovePresentationModal() {
      if (this.workingMode === constants.workspace.PERSONAL) {
        this.isModalMovePresnShowing = true
      } else if (this.workingMode === constants.workspace.TEAM) {
        this.isModalMoveTeamPresentationShowing = true
      }
      Utils.gaTrackEvent(constants.gaCategories.PRESENTATION_LIST, 'Presentation List > Move presentation > Open select the destination modal', null, null, {
        isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
        role: this.$store.state.currentUser.accountRole || null,
        teamId: this.$store.state.currentAccount.id || null,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.import-button {
  &::v-deep {
    svg[name="import"] {
      margin-right: 0;
    }
  }
}
</style>
